const Sidebar = {
    title: 'Il Mio Portfolio',
    myName: 'Ryan Afrizal',
    button: [
        {
            name: 'Home',
            to: '/'
        },
        {
            name: 'Skill',
            to: '/skill'
        },
        {
            name: 'Il Mio Portfolio',
            to: '/project'
        }
    ]
}

export default Sidebar